/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.backlog.rpc.BookmarkRpc
 */
import * as References from './BookmarkRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.backlog.rpc.BookmarkRpc#addBookmark
 */
export const ADD_BOOKMARK_MUTATION_FIELD_NAME = 'com_hubspot_academy_learning_backlog_rpc_BookmarkRpc_addBookmark';
export const ADD_BOOKMARK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ADD_BOOKMARK_MUTATION_FIELD_NAME,
  args: ['contentId', 'contentType'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.addBookmarkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.backlog.rpc.BookmarkRpc#removeBookmark
 */
export const REMOVE_BOOKMARK_MUTATION_FIELD_NAME = 'com_hubspot_academy_learning_backlog_rpc_BookmarkRpc_removeBookmark';
export const REMOVE_BOOKMARK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REMOVE_BOOKMARK_MUTATION_FIELD_NAME,
  args: ['contentId', 'contentType'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.removeBookmarkRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.backlog.rpc.BookmarkRpc#getBookmarks
 */
export const GET_BOOKMARKS_QUERY_FIELD_NAME = 'com_hubspot_academy_learning_backlog_rpc_BookmarkRpc_getBookmarks';
export const GET_BOOKMARKS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BOOKMARKS_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getBookmarksRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});